// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"1b17e4f7","660":"9fb297cd"}[chunkId] + ".chunk.js";
};